import BulletList from '@tiptap/extension-bullet-list'

export default BulletList.extend({
  addAttributes () {
    return {
      ...this.parent?.(),
      type: { default: 'bullet-list', rendered: false }
    }
  }
})